import S from 'common/service/sanctuary';
import React from 'react';
import { connect } from 'react-redux';
import { oneOf, shape, string } from 'prop-types';
import { load } from 'common/store/customer/logo/actions';
import { selectors, } from 'common/store/customer/logo';
import Toolbar, { ToolbarRow, ToolbarSection } from 'common/mdc/toolbar';
import { ALIGN_START, ALIGN_END } from 'common/mdc/toolbar/section';

class CustomerLogo extends React.PureComponent {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    this.props.load();
  }

  render() {
    const { logo } = this.props;

    return (
      <div>
        {logo.left && (
          <ToolbarSection align={ALIGN_END} shrink>
            <img className = "customer_logo" src = {logo.left} onerror="this.style.display='none'"/>
          </ToolbarSection>
        )}
        {logo.right && (
          <ToolbarSection align={ALIGN_END} shrink>
            <img className = "customer_logo" src = {logo.right} onerror="this.style.display='none'"/>
          </ToolbarSection>
        )}
      </div>
    );
  }
}

CustomerLogo.propTypes = {
  logo: shape({
    left: string,
    right: string,
  }).isRequired,
};

export default
connect(
  state => ({
    logo: S.fromMaybe({}, selectors.getLogoMaybe(state)),
    loading: selectors.isLoading(state),
  }),
  {
    load,
  },
)(CustomerLogo);
